module.exports = __webpack_public_path__ + "img/lyra-logo.37fe4c34.svg";